import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'grid-view-create-claim-button',
  template: `
    <button
      *ngIf="text === 'Create claim'; else naText"
      mat-button
      vrm-button
      fxFlex
      [disabled]="!canCreateClaim"
      [innerHtml]="translatedText"
      (click)="createClaim()"
    ></button>
    <ng-template #naText>
      <span>{{ translatedText }}</span>
    </ng-template>
  `,
  styles: [
    `
      button {
        color: white;
        font-size: 12px;
        line-height: 1;
        height: 24px;
        margin-top: 3px;
      }
    `,
  ],
})
export class GridViewCreateClaimButtonComponent implements ICellRendererAngularComp {
  public text: string;
  public translatedText: string;
  public canCreateClaim: boolean;
  private data: any;

  constructor(private cService: CommonService) {}

  public agInit(params: { value: string; data: any }) {
    this.text = params.value;
    this.translatedText = this.cService.getSingleTranslation(`REPORTDATA.${params.value}`, params.value);
    this.canCreateClaim = params.data.canCreateClaim;
    this.data = params.data;
  }

  public destroy(): void {}

  public refresh(): boolean {
    return false;
  }

  public createClaim(): void {
    console.log('CREATING CLAIM... IMPLEMENT!!');
    throw new Error('CREATE CLAIM NOT IMPLEMENTED');
  }
}
